@if (!refreshing) {
  <h6 class="card-title m-0 px-2 py-1 d-flex">
    <mat-icon>local_pharmacy</mat-icon>
    <div class="ms-1 pt-1">Prescriptions</div>
  </h6>
  @if (!refreshing && prescriptions.length > 0) {
    <div class="m{{ eligible ? 'eligible' : 'ineligible' }} t-2 ms-2 mt-2">
      <app-pagination-header [paging]="paging" [label]="'prescriptions'" (pageSizeChange)="onPageSizeChange($event)" />
    </div>
    <app-prescription-list [prescriptions]="prescriptions" [small]="true" [dark]="true" [fixedHeader]="true" [forProvider]="true" />
    <div class="mt-2">
      <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
    </div>
  } @else {
    <div class="m-2">No prescriptions found.</div>
  }
} @else {
  <mat-spinner />
}

